module.exports = __webpack_public_path__ + "readme-owl-85f78c281a8e5770fafcd59a2b365460.webp";